export const listUrl = '/company/efRule/getRule'
export const createUrl = '/company/efRule/createRule'
export const updateUrl = '/company/efRule/{0}'
export const deleteUrl = '/company/efRule/{0}'
export const deleteUrlBatch = '/company/efRule/batch'
export const geofencVehicleListUrl = '/company/efRule/ruleCarList/{0}'

export const alarmListUrl = '/company/efRule/getAlarmRecords'
export const exportUrl = '/company/efRule/export'
export const importGefenceUrl = process.env.VUE_APP_BASEURL + '/company/efRule/import'

export const subUserUrl = '/subject/subUserList'
export const subCarUrl = '/subject/subCarList/{0}'
